export default "__VITE_ASSET__DNHc666f__"